import React from "react";

export default function FooterBar() {
  return (
    <footer className="no-print mt-10 border-t border-slate-200 bg-slate-950 text-slate-300">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-center gap-6">
        <div className="flex items-center gap-4">
          <div className="rounded-xl bg-white px-4 py-2.5 shadow-sm" data-testid="inlife-logo-wrap">
            <img
              src="/inlife-logo.png"
              alt="In Life"
              className="h-9 w-auto"
              data-testid="inlife-logo"
            />
          </div>
          <div className="text-[11px] uppercase tracking-widest text-slate-400">Advanced Ophthalmic Surgical Sciences</div>
        </div>
        <div className="text-xs text-slate-400 sm:ml-auto max-w-md sm:text-right">
          Clinical Decision Support System. Calculations follow Barrett Universal II & True-K, Abulafia-Koch PCA regression, and Cristalens/Artis toric alignment. Verify against manufacturer calculators before surgery.
        </div>
      </div>
    </footer>
  );
}
